module.exports = __webpack_public_path__ + "static/img/contactCenter.7784248.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactpic/contactCenter.jpg
// module id = JkGP
// module chunks = 51